import React, { useContext } from "react";
import { Menu, Container, Button, Dropdown, Image, Sidebar, Segment, Icon, Header } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { Link, NavLink } from "react-router-dom";
import { RootStoreContext } from "../../app/stores/rootStore";

const SideBar: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { user, logout } = rootStore.userStore;
  return (
    <Sidebar 
      as={Menu}
      animation='overlay'
      inverted
      vertical
      visible
      style={{ width: "12%" }}
    >
      <Menu.Item header as={NavLink} exact to="/">
      <Image
            src="/assets/logo_buffalo.png"
            floated="left"
            style={{ width: "100px", marginLeft: '20px', marginTop: '-5px'}}
          />
          <br/>
          &nbsp; 
        </Menu.Item>
        <br/><br/><br/><br/><br/>
      <Menu.Item header as={NavLink} exact to="/projectmanagement">
        <Icon name='edit' />
        Project
      </Menu.Item>
      <br/>
      <Menu.Item header as={NavLink} exact to="/dailymanagement">
        <Icon name='calendar check' />
        Daily Management
      </Menu.Item>
      <br/>
      <Menu.Item header as={NavLink} exact to="/hrmanagement">
        <Icon name='id badge' />
        Human Resource
      </Menu.Item>
      <br/>
      {  (user) && (user.role === 'Accountant' || user.role === 'Super' )  &&
      <div>
      <Menu.Item header as={NavLink} exact to="/financemanagement">
        <Icon name='dollar' />
        Finance
      </Menu.Item>
      <br/></div>}
      <Menu.Item header as={NavLink} exact to="/employeeportal">
        <Icon name='users' />
        Employee Portal
      </Menu.Item>
    </Sidebar>

  );
};

export default observer(SideBar);
